import { useEffect } from 'react';

/**
 * Hook to set page title dynamically
 * @param {string} title - The title to set
 */
const usePageTitle = (title) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} – EventConnect` : 'EventConnect – Event-Dienstleister finden';
    
    // Cleanup: restore previous title on unmount
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default usePageTitle;
